import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, FormFeedback, FormGroup, Input, Label, ListGroup, ListGroupItem } from 'reactstrap';

const TroubleshootList = ({ troubleshoots,componentName,componentId,form, onChange, onSubmit,formErrors }) => {
  const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        const isValid = Object.values(formErrors).every(item => !item);
        setFormValid(isValid);
    }, [formErrors]);

    

    const getDefectMessage = () => {
        if (form.component_condition === 'Defect') {
            return "Defect: Indicates that there is a problem or issue with the component.";
        } else if (form.component_condition === 'No Defect') {
            return "No Defect: Indicates that the component is in good condition and has no issues.";
        }
        return '';
    };

    

    return (
        <div className='bg-light p-3 rounded-2'>
        {/* <h5>Troubleshoots</h5> */}
        {troubleshoots.length > 0 ? (
          <ListGroup>
            {troubleshoots.map(troubleshoot => (
              <ListGroupItem key={troubleshoot.id}>
                {troubleshoot.activity_name}
              </ListGroupItem>
            ))}
          </ListGroup>
        ) : (
          <p>No troubleshoot activities available.</p>
        )}
        
        {/* Report Form */}
        <Form onSubmit={onSubmit} className="mt-4">
          <h5>Enter Report for {componentName}</h5>
          <FormGroup>
            <Label for="defect">Condition:</Label>
            <div>
                <FormGroup check inline>
                  <Label check>
                      <Input 
                      type="radio" 
                      name="defect" 
                      value="Defect" 
                      checked={form.component_condition === 'Defect'} 
                      onChange={(e)=>onChange({name:'component_condition',value:e.target.value})} 
                      />
                      Defect
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                      <Input 
                      type="radio" 
                      name="defect" 
                      value="No Defect" 
                      checked={form.component_condition === 'No Defect'} 
                      // onChange={handleDefectChange} 
                      onChange={(e)=>onChange({name:'component_condition',value:e.target.value})} 
                      />
                      No Defect
                  </Label>
                </FormGroup>
            </div>
            {formErrors.component_condition && <small className='text-danger'>{formErrors.component_condition}</small>}
            </FormGroup>

            {/* Show message based on the selected condition */}
            {form.component_condition && (
                <Alert color='warning'>{getDefectMessage()}</Alert>
            )}
          
          <FormGroup>
            <Label for="remarks">Remarks:</Label>
            <Input 
              type="textarea" 
              name="remarks" 
              id="remarks" 
              value={form.remarks}
              onChange={(e)=>onChange({name:'remarks',value:e.target.value})} 
              valid={formErrors.remarks === ''}
              invalid={formErrors.remarks !== ''}
            />
            {formErrors.remarks && <FormFeedback>{formErrors.remarks}</FormFeedback>}
          </FormGroup>

          <Button 
            disabled={!formValid}
            size='sm' type="submit" color="primary"><span className='ri-inbox-archive-line'></span> Add to Inspection</Button>
        </Form>
      </div>
    );
  };

  export default TroubleshootList;